import commonService from "./ApiServiceClient";

// ✅ Validate user OTP
export const verify_otp_v2 = (params = {}) => commonService.post("grafcare/verify_otp_v2", params);

// ✅ Save treatment plan
export const serviceTreatmentPlan = (params = {}) => commonService.post("grafcare/save_treatment_plan", params);

// ✅ Fetch treatment plan
export const serviceFetchTreatmentPlan = (params = {}) => commonService.post("grafcare/fetch_treatment_plan", params);

// ✅ Book a slot for consultation or treatment
export const bookSlot = (params = {}) => commonService.post("grafcare/book_slots", params);

// ✅ Fetch all booked slots
export const fetchBookings = (params = {}) => commonService.post("grafcare/fetch_booking_slots", params);

// ✅ Register a new user on Grafcare
export const register_grafcare = (params = {}) => commonService.post("grafcare/register_grafcare", params);

// ✅ Upload a prescription for medical orders
export const upload_prescription = (params = {}) => commonService.post("grafcare/upload_prescription", params);

// ✅ Upload KYC (Know Your Customer) documents
export const upload_kyc = (params = {}) => commonService.post("grafcare/upload_kyc", params);

// ✅ Validate mobile number for registration or login
export const validate_mobile = (params = {}) => commonService.post("grafcare/validate_mobile", params);

// ✅ Create a new order for payment processing
export const create_order = () => commonService.get("grafcare/order_payment");

// ✅ Mark an order as successful after payment completion
export const order_success = (params = {}) => commonService.post("grafcare/order_success", params);

// ✅ Validate user access (e.g., authentication check)
export const validate_access = () => commonService.get("grafcare/validate_access");

// ✅ Upload new prescription to order medicine (NEW API)
export const fetch_prescriptions = (params = {}) => commonService.post("grafcare/fetch_prescriptions", params);

// ✅ Refill prescription order (NEW API)
export const refill_prescription = (params = {}) => commonService.post("grafcare/refill_prescription", params);

// ✅ Fetch treatment plan followed by the user
export const fetchTreatmentPlanFollowed = (params = {}) => commonService.post("grafcare/fetch_treatment_plan_followed", params);

// ✅ Generate a presigned URL for file upload
export const generate_presigned_url = (params = {}) => commonService.post("grafcare/generate_presigned_url", params);

